/*
 * @Author: heyuan
 * @Date: 2020-08-19 16:14:23
 * @LastEditors: heyuan
 * @LastEditTime: 2020-08-19 17:43:39
 * @FilePath: \program-name\src\net\Api.js
 */
import axios from 'axios'
import { Message } from 'element-ui'
import {getCookie} from '../untils/common.js'
const instance = axios.create();
instance.defaults.timeout = 2500;

//请求拦截器
instance.interceptors.request.use(config => {
  config.headers = {
    "Bearer": getCookie('token'),
    "tenant": getCookie('headOffice') || 1
  }
  return config
}, error => {
  return Promise.reject(error);
});

//返回拦截器
instance.interceptors.response.use(response=>{
	if (response.data.code != 200) {
    if (response.data.code == 400) {
      return response.data
    }
    if (response.data.code == 4034) {
      return response.data
    }
		Message.error(response.data.message)
		return response.data
	}
	return response.data;
},error=>{
	const { response } = error
	  if (response) {
	    // 处理错误...
	    switch (response.status) {
	      case 401: {
	        Message.error('网络错误')
	        break
	      }
	      case 500: {
	        Message.error('服务器错误')
	        break
	      }
	      default: {

	      }
	    }
	  }
	return Promise.reject(error.data);
});



export const get = (url, params, config = {
  headers: {

  },
}) => {
  //console.log('config', config)
  return instance.get(url, { params, headers: config });
}

export const post = (url, data, config = {
  headers: {

  },
}) => {
  return instance.post(url, data, config);
}

export const post2 = (url, data, config = {}) => {
  return instance.post(url, data, config);
}

export function Del(url, payload) {
    return instance.delete(url, {
        data: payload
    });
}

export function Put(url, par, payload) {
    return instance.put(url, par, {
        data: payload
    })
}



// WEBPACK FOOTER //
// ./src/net/Api.js